import React, { useEffect, useState } from 'react';
import { useLingui } from '@lingui/react/macro';

import {
    CardProgressBarGraphic,
    CardProgressBarSpendTime,
    CardProgressBarWrapper,
    CardProgressMinLeft,
    CardProgressText,
    CardProgressTextPercent,
} from './styled.tsx';

interface Props {
    percentComplete: string;
    minLeft: number;
    isCustomText: boolean;
    bgColor?: string;
    progressColor?: string;
    animated?: boolean;
}

const CardProgressBar: React.FC<Props> = ({
    percentComplete,
    minLeft,
    isCustomText,
    bgColor,
    progressColor,
    animated = false,
}) => {
    const { t } = useLingui();

    const [progress, setProgress] = useState(animated ? '0' : percentComplete);

    useEffect(() => {
        setProgress(percentComplete);
    }, [percentComplete]);

    useEffect(() => {
        if (!animated) return;

        const frame = requestAnimationFrame(() => {
            setProgress(percentComplete);
        });
        return () => cancelAnimationFrame(frame);
    }, [percentComplete, animated]);

    return (
        <CardProgressBarWrapper>
            <CardProgressBarGraphic $bgColor={bgColor}>
                <CardProgressBarSpendTime
                    $progressPercent={progress}
                    $bgColor={progressColor}
                    $animated={animated}
                ></CardProgressBarSpendTime>
            </CardProgressBarGraphic>
            {!isCustomText && (
                <CardProgressText>
                    <CardProgressTextPercent>
                        {percentComplete}% {t`completed`}
                    </CardProgressTextPercent>
                    <CardProgressMinLeft>
                        {minLeft} {t`min left`}
                    </CardProgressMinLeft>
                </CardProgressText>
            )}
        </CardProgressBarWrapper>
    );
};

export default CardProgressBar;
